import Cookies from "universal-cookie";

// The backend keeps the login in the HttpOnly `auth_token` cookie, which
// scripts cannot read and the browser sends along by itself. `aa_session` is
// its readable companion: it tells the app that someone is logged in and
// carries no credential. Both are set and cleared by the backend.
export const SESSION_HINT_COOKIE = "aa_session";

const cookies = new Cookies();

// `auth_token` still counts while a stack runs with AUTH_COOKIE_HTTP_ONLY=false.
export const isLoggedIn = () =>
  Boolean(cookies.get(SESSION_HINT_COOKIE) || cookies.get("auth_token"));

// Forgets the login on this page only; /api/session/clear ends it on the
// backend, the login pages go there.
export const forgetSession = () => {
  cookies.remove(SESSION_HINT_COOKIE, { path: "/" });
  cookies.remove("auth_token", { path: "/" });
};
